import { Component, OnInit, output } from '@angular/core';
import { LoginService } from 'src/app/login/login.service';

@Component({
    selector: 'asset-loading-dialog',
    templateUrl: './asset-loading-dialog.component.html'
})
export class AssetLoadingDialogComponent implements OnInit {
  readonly onLogoutButtonClick = output<void>();
  readonly onRetryButtonClick = output<void>();

  constructor() {  }

  ngOnInit(): void {}

  logoutBtnDialogClick() {
    this.onLogoutButtonClick.emit() ;
  }

  retryBtnDialogClick() {
    this.onRetryButtonClick.emit() ;
  }
}
